import cx from 'classnames';
import type React from 'react';
import styles from './style.module.css';

export type ToastT = 'entering' | 'visible' | 'exiting';

type NotificationT = {
  text: string;
  type: 'error' | 'success' | 'warning';
  animationState: ToastT;
};

const Notification: React.FC<NotificationT> = ({
  text,
  type,
  animationState,
}) => {
  return (
    <div
      className={cx(styles.notification, styles[type], styles[animationState])}
    >
      <p>{text}</p>
    </div>
  );
};

export default Notification;
